import axios from 'axios';

const GET_CUSTOMER_DETAILS = '/.netlify/functions/getCustomerDetail';

const GetCustomerDetails = async () => {
  const fetchData = async() => {
    try {
      let customerDetailsResponse = await axios.post(GET_CUSTOMER_DETAILS,
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      );

      if (customerDetailsResponse.status == 200) {
        return customerDetailsResponse.data;
      } else {
        return [];
      }
    } catch (err) {
      console.log(err);
      return [];
    }
  };

  return await fetchData();
};

export default GetCustomerDetails;